<script>
import Btn from "@/components/atoms/Btn";
import BtnRow from "@/components/atoms/BtnRow";
export default {
  components: {Btn, BtnRow},
  props: ['saveFile', 'showOptions', 'selected', 'save', 'open'], 
  mounted(){
    this.getImageURL();
    this.getPartLedger();
  },
  data(){
    return {
      url: null,
      preShippingTotal: null,
      ledger: null
    }
  },
  computed: {
    time(){
      return this.saveFile.time;
    },
    imageName(){
      return this.saveFile.imageName;
    },
    partCount(){
      return this.$store.get('parts/getPartCountFromLedger', this.ledger)
    },
  },
  watch: {
    time(){
      this.getImageURL();
      this.getPartLedger();
      setTimeout(() => {
        this.getImageURL();
      }, 2000)
    },
  },
  methods: {
    getPartLedger(){
      if(this.saveFile){
        this.ledger = this.$store.get('saveFiles/getLedger', this.saveFile)
        this.$store.dispatch("payment/getOrderFromLedger", this.ledger).then(order => {
          if(order){
            // console.log(order);
            this.preShippingTotal = order.preShippingTotal
            this.ledger = order.ledger
          }else{
            console.error("Failed to get order: "+this.saveFile.id);
          }
        });
      }
    },
    getImageURL(){
      if(this.saveFile){
        if(this.$route.matched.some(({ name }) => name === 'Templates')){
          this.$store.dispatch("saveFiles/getPublicImage", this.imageName).then(url => this.url = url);
        }else{
          this.$store.dispatch("saveFiles/getImage", this.imageName).then(url => this.url = url);
        }
      }
    }
  }
}
</script>

<template>
  <div class="save-file">
    <div class="existing-project card" @click="$emit('click', saveFile)" :class="{'selected': selected}">
      <div class="card-overlay new-button" v-if="save">
        <div class="fa fa-save"></div>
        Save As
      </div>
      <div class="card-overlay new-button" v-if="open">
        <div class="fa fa-head-vr"></div>
        Load Project
      </div>
      <div class="col left">
        <div class="image-container">
          <img class="image" :src="url" />
        </div>
      </div>
      <div class="col right">
        <div class="project-name">
          {{saveFile.name}}
        </div>
        <div class="row-container">
          <div class="row">
            <div class="detail">
              <div class="label">
                Last Modified
              </div>
              <div class="value">
                {{new Date(saveFile.time+' UTC').toLocaleString()}}
              </div>
            </div>
            <!-- <div class="detail right">
              <div class="label">
                User
              </div>
              <div class="value">
                {{saveFile.userID}}
              </div>
            </div> -->
          </div>
          <div class="row">
            <div class="detail">
              <div class="label">
                Parts
              </div>
              <div class="value">
                {{partCount}}
              </div>
            </div>
            <div class="detail right">
              <div class="label">
                est. Total
              </div>
              <div class="value">
                {{preShippingTotal ? "$"+preShippingTotal : "..."}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="false" class="button-row">
      <btn type="fill" class="load" @click="$emit('load', saveFile)">Load Project</btn>
      <!-- <btn type="fill" class="purchase" color="secondary">Share</btn> -->
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~@/styles/constants";
.save-file{
  position: relative;
  flex-basis: 32rem;
  .button-row{
    display: flex;
    padding: 0rem 2rem;
    margin-top: -2rem;
    .load{
      flex: 1;
    }
    .purchase{
      width: 16rem;
    }
  }
}
.card{
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  flex-basis: 30rem;
  height: 32rem;
  // min-width: 32rem;
  min-height: 32rem;
  // margin: 1rem;
  margin: 1rem;
  // margin-top: 3rem;
  border-radius: 0.5rem;
  transition: transform 0.3s ease;
  box-shadow: $z_depth_2;
  background-color: $card_background;
  &.selected{
    border: 4px solid $p;
  }
  &.add-name{
    &:hover, &.hover{
      transform: scale(1);
    }
    * {
      pointer-events: auto;
    }
  }
  &:hover, &.hover{
    transform: scale(1.025);
    cursor: pointer;
    .card-overlay{
      opacity: 1;
    }
  }
  * {
    pointer-events: none;
  }
  .card-overlay{
    border-radius: 0.5rem;
    position: absolute;
    top: 0rem;
    left: 0rem;
    width: 100%;
    height: 100%;
    opacity: 0;
    transition: opacity 0.1s ease;
    // display: flex;
    // align-items: center;
    // justify-content: center;
    background-color: rgba(178, 99, 247, 0.8);
    // z-index: 2;
    // font-size: 2rem;
  }
  .col{
    &.left{
      flex: 1;
      // padding: 1rem 0rem 1rem 1rem;
      overflow: hidden;
      .image-container{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        // width: 21rem;
        overflow: hidden;
        border-radius: 0.5rem;
        .image{
          overflow: hidden;
          // max-width: 100%;
          width: 100%;
          filter: brightness(2.5);
        }
      }
    }
    &.right{
      display: flex;
      align-items: stretch;
      flex-direction: column;
      padding: 1.5rem;
      .project-name{
        // margin-bottom: 1rem;
        font-size: 1.5rem;
      }
      .row-container{
        flex: 1;
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        flex-direction: column;
      }
      .row{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
      .detail{
        display: flex;
        align-items: flex-start;
        justify-content: center;
        flex-direction: column;
        margin-top: 1rem;
        &.right{
          align-items: flex-end;
        }
        .label{
          color: $w_1;
          font-size: 1rem;
          margin-bottom: 0.25rem;
        }
        .value{
          font-size: 1.25rem;
        }
      }
    }
  }
}
</style>